import { HttpErrorResponse } from '@angular/common/http';

import { isApiServerError } from 'idt-ecommerce-api/_api/api-errors/api-errors.models';
import { EcommerceError } from 'idt-ecommerce-api/errors/errors.models';


/** Clase de utilidad para transformar los errores que devuelve el api de inditex en objetos más usables para el cms, widgets y render */

export class ErrorsModelsTransformer {

  public static ecommerceErrorFromApi(httpError: HttpErrorResponse): EcommerceError {
    const requestedUrl = httpError.url;
    const httpStatus = httpError.status;
    const error = httpError.error;
    let ecommerceError: EcommerceError;

    if (isApiServerError(error)) {
      ecommerceError = {
        requestedUrl,
        message: error.description,
        key: error.key,
        httpStatus,
        originalError: error
      };
    } else {
      let key;
      let message: string = '';
      let originalError = error;

      if (typeof (error) === 'string') {
        message = error;
        originalError = null;
      }

      switch (httpStatus) {
        case 400:
          message = message || 'Bad request';
          key = 'HTTP_BAD_REQUEST';
          break;
        case 403:
          message = message || 'Insufficient permission';
          key = 'HTTP_FORBIDDEN';
          break;
        case 404:
          message = message || 'Requested resource not found';
          key = 'HTTP_NOT_FOUND';
          break;
        case 413:
          message = message || 'REQUEST_ENTITY_TOO_LARGE';
          key = 'PAYLOAD_TOO_LARGE';
          break;
        case 422:
          key = 'UNPROCESSABLE_ENTITY';
          break;
        case 500:
          message = message || 'Internal server error';
          key = 'HTTP_INTERNAL_SERVER_ERROR';
          break;
        default:
          message = message || 'Unspecified HTTP error';
          key = 'GENERAL_HTTP_ERROR';
      }

      ecommerceError = {
        requestedUrl,
        message,
        key,
        httpStatus,
        originalError
      };
    }

    return ecommerceError;
  }

}
